import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import {
  CmsPageAdapter,
  CMS_PAGE_NORMALIZER,
  ContentPageMetaResolver,
  I18nModule,
  provideDefaultConfig,
  RoutingConfig
} from '@spartacus/core'
import { CmsPageGuard } from '@spartacus/storefront'
import { ebPageMetaConfig } from './config/eb-page-meta.config'
import { EbCmsPageNormalizer } from './converters/normalizers/eb-cms-page.normalizer'
import { EbCmsPageGuard } from './guards/eb-cms-page.guard'
import { EbContentPageMetaResolver } from './pages/eb-content-page-meta.resolver'
import {
  EB_PRODUCT_DETAILS_URL_MATCHER,
  EB_VARIANT_DETAILS_URL_MATCHER
} from './pages/eb-product-details-url-matcher'
import { EbCmsPageAdapter } from './services/connectors/eb-cms-page.adapter'

@NgModule({
  imports: [CommonModule, I18nModule],
  providers: [
    {
      provide: CmsPageAdapter,
      useClass: EbCmsPageAdapter
    },
    {
      provide: CmsPageGuard,
      useClass: EbCmsPageGuard
    },
    {
      provide: ContentPageMetaResolver,
      useClass: EbContentPageMetaResolver
    },
    {
      provide: CMS_PAGE_NORMALIZER,
      useExisting: EbCmsPageNormalizer,
      multi: true
    },
    provideDefaultConfig({
      routing: {
        routes: {
          product: {
            matchers: [EB_PRODUCT_DETAILS_URL_MATCHER, EB_VARIANT_DETAILS_URL_MATCHER]
          }
        }
      }
    } as RoutingConfig),
    provideDefaultConfig(ebPageMetaConfig)
  ]
})
export class EbCmsModule {}
